import { useEffect } from "react";

const SEO = ({ title, description, image, url, type = "website" }) => {
  useEffect(() => {
    // Title management
    const siteTitle = "Frantzley Adolphe | Full Stack Developer";
    const fullTitle = title ? `${title} | Frantzley Adolphe` : siteTitle;
    document.title = fullTitle;

    const updateMeta = (name, property, content) => {
      if (!content) return;
      let element = property
        ? document.querySelector(`meta[property="${property}"]`)
        : document.querySelector(`meta[name="${name}"]`);

      if (!element) {
        element = document.createElement("meta");
        if (property) element.setAttribute("property", property);
        if (name) element.setAttribute("name", name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    const metaDescription =
      description ||
      "Official portfolio of Frantzley Adolphe (Adolphe Frantzley), a Full Stack Web Developer & UI Designer. Explore modern web solutions, project highlights, and tech insights.";

    const metaKeywords =
      "Frantzley Adolphe, Adolphe Frantzley, Frantzley, Adolphe, Full Stack Developer, Web Developer, Portfolio, Software Engineer, Photographer, UI/UX Designer ";

    const metaImage =
      image ||
      "https://res.cloudinary.com/dpv06l6i8/image/upload/v1/portfolio/og-image.png";
    const metaUrl = url || window.location.href;

    // Standard Tags
    updateMeta("description", null, metaDescription);
    updateMeta("keywords", null, metaKeywords);
    updateMeta("author", null, "Frantzley Adolphe");
    updateMeta("robots", null, "index, follow");

    // Open Graph
    updateMeta(null, "og:title", fullTitle);
    updateMeta(null, "og:description", metaDescription);
    updateMeta(null, "og:image", metaImage);
    updateMeta(null, "og:site_name", "Frantzley Adolphe Portfolio");
    updateMeta(null, "og:url", metaUrl);
    updateMeta(null, "og:type", type);

    // Twitter
    updateMeta("twitter:card", null, "summary_large_image");
    updateMeta("twitter:title", null, fullTitle);
    updateMeta("twitter:description", null, metaDescription);
    updateMeta("twitter:image", null, metaImage);

    // JSON-LD Schema (Structured Data)
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Frantzley Adolphe",
      alternateName: "Adolphe Frantzley",
      url: "https://frantzleyadolphe.com", // Replace with your actual domain
      jobTitle: "Full Stack Web Developer",
      description: metaDescription,
      image: metaImage,
      sameAs: [
        "https://github.com/yourusername",
        "https://linkedin.com/in/yourusername",
        "https://twitter.com/yourusername",
      ],
    };

    let scriptTag = document.querySelector(
      'script[type="application/ld+json"]',
    );
    if (!scriptTag) {
      scriptTag = document.createElement("script");
      scriptTag.setAttribute("type", "application/ld+json");
      document.head.appendChild(scriptTag);
    }
    scriptTag.text = JSON.stringify(schemaData);
  }, [title, description, image, url, type]);

  return null;
};

export default SEO;
